(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('archive', archive);

    /* @ngInject */
    function archive() {
        var directive = {
            bindToController: true,
            templateUrl: 'archive.tpl',
            controller: archiveController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '<'
            }
        };
        return directive;
        /////////////////

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function archiveController() {
    }

})();